import request from "../../../core/wrappers/axios-wrapper";
import { ApiURL } from "../../../types/constants/apiUrls/api-urls";
import { RequestType } from "../../../types/enums/request-enums";

const GetSmsTemplate = () =>
  request({
    url: ApiURL.Query.GetSmsTemplate,
    method: RequestType.GET,
  });
const SmsTemplateQuery = {
 GetSmsTemplate
};

export default SmsTemplateQuery;
